<script setup lang="ts">
import { computed } from "vue";
import { ChartData, ChartOptions } from "chart.js/auto";
import { useColorSchemeStore } from "../../stores/color-scheme";
import { useDarkModeStore } from "../../stores/dark-mode";
import Chart from "../../base-components/Chart";
import { getColor } from "../../utils/colors";

const props = defineProps<{
  width?: number;
  height?: number;
  dataMap: { [key: string]: number };
}>();

const colorScheme = computed(() => useColorSchemeStore().colorScheme);
const darkMode = computed(() => useDarkModeStore().darkMode);

const chartColors = () => [
  "#751B4E",
  "#74AA81",
  "#E09C2D",
  "#B3617F",
  "#74AA81",
  "#1B6075",
  "#4D1F7C"
  // getColor("success", 0.9),
  // getColor("primary", 0.9),
  // getColor("danger", 0.9),
  // getColor("pending", 0.9),
  // getColor("dark", 0.9),
  // getColor("warning", 0.9),
  // getColor("info", 0.9)
];

const data = computed<ChartData>(() => {
  return {
    labels: Object.keys(props.dataMap),
    datasets: [
      {
        data: Object.values(props.dataMap),
        backgroundColor: colorScheme.value ? chartColors() : "",
        hoverBackgroundColor: colorScheme.value ? chartColors() : "",
        borderWidth: 1,
        borderColor: darkMode.value
          ? getColor("darkmode.700")
          : getColor("slate.700")
      }
    ]
  };
});

const options = computed<ChartOptions>(() => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        labels: {
          color: getColor("slate.500", 0.8)
        }
      }
    }
  };
});
</script>

<template>
  <Chart
    type="pie"
    :width="props.width"
    :height="props.height"
    :data="data"
    :options="options"
  />
</template>
